<div class="horizontal-scroll">
    <ng-container *ngFor="let item of items">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
    </ng-container>
</div>